var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissionBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22.1635H4.72578L12.5262 14.4589L10.1616 12.1229L0 22.1635ZM0 29H39.9289L20.7796 10.0834V4.72356H25.5311L24.2551 2.7134L25.6075 0.69981H20.7724C20.7186 0.307037 20.3766 0 19.9651 0C19.5137 0 19.1474 0.361901 19.1474 0.807824V10.0834L0 29ZM19.9653 11.4468L11.6649 19.6436L13.5468 20.7224L17.0399 18.918L19.9635 21.8047L22.8854 18.918L26.3784 20.7224L28.2604 19.6436L19.9653 11.4468ZM35.2031 22.163H40L29.8404 12.1225L27.4394 14.4929L35.2031 22.163Z",
    fill: "#00A9DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionBlueIcon);
export default __webpack_public_path__ + "static/media/missionBlueIcon.2a6dbe56e37b5bc727c91cc1fa0222ba.svg";
export { ForwardRef as ReactComponent };